import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/Authorization/csruser`;
const url = process.env.REACT_APP_API_BASE_URL + "/api";

const login = async (username, password, ipAddress, isLastAttempt) => {
  const response = await axios.get(API_URL, {
    headers: {
      username,
      password,
      ipAddress,
      isLastAttempt,
    },
  });

  return response;
};

const logout = () => {
  localStorage.clear();
};

const loginWithToken = (shortToken) => {
  return axios.post(url + "/authorizationV2/AccessToken/ShortToken", {
    shortToken,
  });
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  login,
  logout,
  loginWithToken,
};
